import { render } from "./CourseItemsGroupedVariant.vue?vue&type=template&id=093b6d62"
import script from "./CourseItemsGroupedVariant.vue?vue&type=script&lang=js"
export * from "./CourseItemsGroupedVariant.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__